declare const jobData: any;

import * as JobTypes from "../types/jobData";

const jobDataLength = jobData.length;

export class Pagination {
  private paginationCallback: (pageJobs: JobTypes.jobData[]) => void = () => {}; // Callback Function

  public foundJobs: JobTypes.jobData[];
  public currentPage: number;
  public perPage: number;

  public totalJobs: number = jobDataLength;
  public startEntrys: number = 0;
  public endEntrys: number = 0;

  constructor(jobs: JobTypes.jobData[], entrysPerPage: number = 10) {
    this.foundJobs = jobs;
    this.currentPage = 1;
    this.perPage = entrysPerPage;

    this.setEvents();
  }

  public onPageChange(callback: (pageJobs: JobTypes.jobData[]) => void) {
    this.paginationCallback = callback; // 🔥 Callback
  }

  private updateSliderVisibilityClass() {
    const container = document.querySelector(".dt-container__main");
  
    if (!container) return;
  
    const shouldDisableSlider = this.foundJobs.length <= this.perPage;
  
    container.classList.toggle("no-slider-needed", shouldDisableSlider);
  }

  update(jobs: JobTypes.jobData[] | undefined = undefined) {
    if (jobs != undefined) {
      // only when new jobs are passed
      this.foundJobs = jobs;
      this.resetPagination();
    }

    this.calculatePaginationData();
    this.paginationCallback(this.getPageJobs()); // 🔥 Callback
    this.updateSliderVisibilityClass(); // 👈 hier hinzufügen
  }

  private resetPagination() {
    this.currentPage = 1;
  }

  public getPageJobs(): JobTypes.jobData[] {
    const start = (this.currentPage - 1) * this.perPage;
    const end = start + this.perPage;
    return this.foundJobs.slice(start, end);
  }

  public nextPage() {
    if (this.currentPage * this.perPage < this.foundJobs.length) {
      this.currentPage++;
      this.update();
    }
  }

  public prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.update();
    }
  }

  public getTotalPages(): number {
    return Math.ceil(this.foundJobs.length / this.perPage);
  }

  private setEvents() {}

  private calculatePaginationData() {
    this.totalJobs = this.foundJobs.length;
    const currentPage = this.currentPage;

    // calculate start and end Page of the current page
    this.startEntrys = (currentPage - 1) * this.perPage + 1;
    this.endEntrys = Math.min(currentPage * this.perPage, this.totalJobs);
  }
}

export class PaginationUI {
  private pagination: Pagination;

  // T R A N S L A T I O N S
  private openJobsText: string = jobData.openJobsText;
  private openJobsTextMobile: string = jobData.openJobsTextMobile;
  private jobsCountText: string = jobData.jobsCountText;

  constructor(paginationInstance: Pagination) {
    this.pagination = paginationInstance;
    this.init();
  }

  private init() {
    document.querySelectorAll<HTMLButtonElement>(".button-next-page").forEach((button) => {
      button.addEventListener("click", () => {
        this.pagination.nextPage();
        this.updatePaginationUI();
      });
    });

    document.querySelectorAll<HTMLButtonElement>(".button-prev-page").forEach((button) => {
      button.addEventListener("click", () => {
        this.pagination.prevPage();
        this.updatePaginationUI();
      });
    });
  }

  // TODO: Where will it be called?
  public updatePaginationUI() {
    this.renderPaginationData();
    this.handleActiveStateOfPaginationButtons();
  }

  /**
   * Renders the pagination data - e.g. "{X} offene Jobs für dich"
   *
   */
  private renderPaginationData() {
    const availableJobsCount = document.getElementById("avaiable-jobs-count");

    if (availableJobsCount) {
      if (this.pagination.totalJobs === 0) {
        availableJobsCount.textContent = jobData.jobsCountText
          .replace("{total}", this.pagination.totalJobs.toString())
          .replace("{current}", "0");
      } else {
        availableJobsCount.textContent = jobData.jobsCountText
          .replace("{total}", this.pagination.totalJobs.toString())
          .replace("{current}", `${this.pagination.startEntrys}-${this.pagination.endEntrys}`);
      }
    }

    const openJobs = document.getElementsByClassName("js-open-jobs") as HTMLCollectionOf<HTMLElement>;
    if (openJobs) {
      for (let i = 0; i < openJobs.length; i++) {
        // Text for mobile  📱
        if (openJobs[i].classList.contains("js-open-jobs--mobile")) {
          openJobs[i].textContent = this.openJobsTextMobile.replace("{total}", this.pagination.totalJobs.toString());
        }
        // Text for desktop 💻
        else {
          openJobs[i].textContent = `${this.pagination.totalJobs} ${this.openJobsText}`;
        }
      }
    }
  }

  private handleActiveStateOfPaginationButtons() {
    const prevDisabled = this.pagination.currentPage === 1 || this.pagination.foundJobs.length === 0;
    const nextDisabled =
      this.pagination.currentPage === this.pagination.getTotalPages() || this.pagination.foundJobs.length === 0;

    document.querySelectorAll(".button-prev-page").forEach((button) => {
      button.toggleAttribute("disabled", prevDisabled);
      button.classList.toggle("inactive", prevDisabled);
    });

    document.querySelectorAll(".button-next-page").forEach((button) => {
      button.toggleAttribute("disabled", nextDisabled);
      button.classList.toggle("inactive", nextDisabled);
    });
  }
}
